import React from 'react';
import { Link } from 'react-router-dom';
import { FaCheckCircle, FaArrowRight, FaTrophy, FaUsers, FaMedal, FaHeart } from 'react-icons/fa';
import './About.css';

const PersonalCoachingSkillDevelopment = () => {

    return (
        <div className="about-page">
            {/* Main About Section */}
            <section className="about-main section">
                <div className="container">
                    <div className="about-main-grid">
                        <div className="about-main-content">
                            <h2>Personal Coaching & Skill Development</h2>
                            <p>
                                The Personal Coaching & Skill Development program at Net Nest Badminton Sports Club is designed for players who seek focused, individualized training to accelerate their improvement. This program offers customized coaching plans tailored to each player’s specific needs, goals, and skill level, ensuring maximum progress in minimum time.
                            </p>
                            <h2>Program Overview</h2>
                            <p>
                                Unlike group training sessions, personal coaching provides one-on-one attention from experienced coaches. This allows for in-depth analysis of technique, movement, and performance. Whether a player wants to correct basics, refine advanced skills, or prepare for competition, this program delivers targeted and effective training.
                            </p>
                        </div>
                        <div className="about-main-images">
                            <img src="img/Personal Coaching & Skill Development.jpg" alt="Badminton Court" className="main-image" />
                        </div>
                    </div>
                    <div className="about-main-grid">
                        <div className="about-main-content">
                            <h2>Individual Skill Assessment</h2>
                            <p>
                                Technical strengths and weaknesses
                                <br></br>
                                Footwork efficiency and court movement
                                <br></br>
                                Shot accuracy and consistency
                                <br></br>
                                Fitness level and endurance
                                <br></br>
                                Match temperament and mental approach
                            </p>
                        </div>
                        <div className="about-main-images">
                            <h2>Customized Training Plans</h2>
                            <p>
                                Improving specific strokes (smash, drop, net play, defense)
                                <br></br>
                                Enhancing footwork speed and agility
                                <br></br>
                                Developing consistency and shot control
                                <br></br>
                                Preparing for tournaments or trials
                            </p>
                        </div>
                        <div className="about-main-images">
                            <h2>Technical Correction & Precision Training</h2>
                            <p>
                                Personal coaching allows coaches to closely monitor every movement and stroke. Immediate correction and feedback help players eliminate bad habits and develop proper techniques. This precision-based training builds confidence, control, and consistency on the court.
                            </p>
                        </div>
                        <div className="about-main-images">
                            <h2>Fitness & Movement Enhancement</h2>
                            <p>
                                Speed and agility
                                <br></br>
                                Strength and balance
                                <br></br>
                                Endurance and flexibility
                            </p>
                        </div>
                        <div className="about-main-images">
                            <h2>Mental Strength & Confidence Building</h2>
                            <p>
                                Build self-confidence
                                <br></br>
                                Improve focus and concentration
                                <br></br>
                                Handle pressure during matches
                                <br></br>
                                Develop a positive and disciplined mindset
                            </p>
                        </div>
                        <div className="about-main-images">
                            <h2>Flexible Scheduling & Focused Attention</h2>
                            <p>
                                Personal coaching offers flexible scheduling, making it ideal for school students, working professionals, and competitive players. One-on-one attention ensures faster learning and efficient use of training time.
                            </p>
                        </div>
                        <div className="about-main-images">
                            <h2>Who Should Choose Personal Coaching?</h2>
                            <p>
                                Players needing individual attention
                                <br></br>
                                Athletes preparing for competitions
                                <br></br>
                                Players aiming to correct specific weaknesses
                                <br></br>
                                Beginners wanting strong fundamentals
                                <br></br>
                                Advanced players seeking performance refinement
                            </p>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default PersonalCoachingSkillDevelopment;
